import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import DashboardShell from '../../components/dashboard/DashboardShell';

export default function DashboardRouter() {
  const { state } = useAuth();

  if (state.loading) {
    return (
      <DashboardShell title="Φόρτωση πίνακα...">
        <div className="text-gray-400">Φόρτωση λογαριασμού.</div>
      </DashboardShell>
    );
  }

  if (!state.user) {
    return <Navigate to="/dashboard/login" replace />;
  }

  if (state.user.isActive === false) {
    return (
      <DashboardShell title="Απενεργοποιημένος λογαριασμός">
        <p className="text-gray-300">Ο λογαριασμός σου είναι απενεργοποιημένος. Επικοινώνησε με τον διαχειριστή.</p>
      </DashboardShell>
    );
  }

  if (state.user.role === 'admin') {
    return <Navigate to="/dashboard/admin" replace />;
  }

  if (state.user.role === 'artist') {
    return <Navigate to="/dashboard/artist" replace />;
  }

  return (
    <DashboardShell title="Μη επιτρεπτή πρόσβαση">
      <p className="text-gray-300">Ο λογαριασμός σου δεν έχει πρόσβαση στον πίνακα.</p>
    </DashboardShell>
  );
}
